// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3pmGS","empty":"ModalGraph_empty__3Fvaf"};